import React, { useEffect, useState } from 'react'
import NavbarContainer from '../components/Navbar/Navbar'
import AccountSidebar from '../components/AccountSidebar/AccountSidebar'
import TermsContainer from '../components/TermsContainer/TermsContainer'
import Footer from '../components/Footer/Footer'
import { Col, Container, Row } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'
import axios from 'axios'
import Loading from './Loading'
import { useSelector } from 'react-redux'

function Terms() {
  const { pathname } = useLocation();
  const layout = useSelector((state) => state.layoutRducer.layoutArray);

  useEffect(() => {
    window.scrollTo(0, 0);

  }, [pathname]);

  return (
 

    <>
    <NavbarContainer/>
    <Container>
      <Row>
    
        <TermsContainer layout={layout}/>


      </Row>
    </Container>
    <Footer/>
    </>  )
}

export default Terms